import { render, staticRenderFns } from "./pdfTemplate.vue?vue&type=template&id=547e82fe&scoped=true"
import script from "./pdfTemplate.vue?vue&type=script&lang=js"
export * from "./pdfTemplate.vue?vue&type=script&lang=js"
import style0 from "./pdfTemplate.vue?vue&type=style&index=0&id=547e82fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547e82fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('547e82fe')) {
      api.createRecord('547e82fe', component.options)
    } else {
      api.reload('547e82fe', component.options)
    }
    module.hot.accept("./pdfTemplate.vue?vue&type=template&id=547e82fe&scoped=true", function () {
      api.rerender('547e82fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/order/components/pdfTemplate.vue"
export default component.exports